import Vue from "vue";
import Router from "vue-router";
import Base from "./views/Base.vue";

Vue.use(Router);

import { loadLocale } from "@/locales/languages.js";
const defaultLocale = loadLocale();
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: `/${defaultLocale}`
    },
    {
      path: "/:locale",
      component: Base,
      children: [
        {
          path: "",
          name: "home",
          component: () =>
            import(/* webpackChunkName: "Home" */ "@/views/Home/Index.vue")
        }
      ]
    }
  ]
});
